import React from "react";
import { Box } from "@mui/material";
import { entreeDe } from "../navigation/plan";
import { estSuperAdmin } from "../api/role";
import { COULEUR_DOMAINE, Domaine } from "../theme/tribeTheme";
import EnTetePage from "../components/charte/EnTetePage";
import CarteLien from "../components/charte/CarteLien";
import TitreSection from "../components/charte/TitreSection";
import { useAttente } from "../navigation/attente";
import { AIDE_DOMAINE } from "../aide/textesAide";

/* Page d'accueil d'une entrée du menu : la liste de ses sous-pages (titre,
   une phrase, lien). Les pages rangées ailleurs apparaissent en raccourci
   avec la mention de leur emplacement. */

const COMPTEUR_DE: Record<string, "lieux" | "reponses" | "quetes" | "retraits"> = {
  "/a-traiter/lieux": "lieux",
  "/a-traiter/lieux?onglet=reponses": "reponses",
  "/a-traiter/quetes": "quetes",
  "/argent/retraits": "retraits",
};

export default function PageDomaine({ cle, avant }: { cle: Domaine; avant?: React.ReactNode }) {
  const entree = entreeDe(cle);
  const superAdmin = estSuperAdmin();
  const attente = useAttente();
  const sousPages = entree.sousPages.filter(p => !p.superAdmin || superAdmin);

  return (
    <Box sx={{ p: { xs: 2, md: 3.5 }, maxWidth: 1280 }}>
      <EnTetePage
        domaine={cle}
        titre={entree.libelle}
        phrase={entree.phrase}
        aide={AIDE_DOMAINE[cle]}
      />
      {avant}
      <TitreSection titre={avant ? "Toutes les pages" : "Pages"} />
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }, gap: 2 }}>
        {sousPages.map(p => {
          const k = COMPTEUR_DE[p.chemin];
          return (
            <CarteLien
              key={p.chemin}
              titre={p.titre}
              phrase={p.phrase}
              chemin={p.chemin}
              lisere={COULEUR_DOMAINE[p.rangeeDans ?? cle]}
              compteur={k ? attente.lignes[k]?.nombre : undefined}
              mention={p.rangeeDans ? `Rangée dans ${entreeDe(p.rangeeDans).libelle}` : undefined}
            />
          );
        })}
      </Box>
    </Box>
  );
}
